import { render, staticRenderFns } from "./customerSubmitModel.vue?vue&type=template&id=3eedb847&scoped=true&"
import script from "./customerSubmitModel.vue?vue&type=script&lang=js&"
export * from "./customerSubmitModel.vue?vue&type=script&lang=js&"
import style0 from "./customerSubmitModel.vue?vue&type=style&index=0&id=3eedb847&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eedb847",
  null
  
)

export default component.exports